import { createEntityListPage } from "./createEntityListPage";
import {
  useExpenseTypes,
  useAddExpenseType,
  useUpdateExpenseType,
} from "../../api/lists";

export const ExpenseTypesPage = createEntityListPage({
  title: "Expense Types",
  entityType: "expense-type",
  useList: useExpenseTypes,
  useAdd: useAddExpenseType,
  useUpdate: useUpdateExpenseType,
});
